import createVueComponent from '../createVueComponent';

const SignalLow = createVueComponent('SignalLowIcon', [
  ['path', { d: 'M2 20h.01', key: '4haj6o' }],
  ['path', { d: 'M7 20v-4', key: 'j294jx' }],
]);

export default SignalLow;
